import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Backdrop, Modal } from '@material-ui/core';
import { AssuranceIcon } from 'images';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export default function TransitionsModal(props: any) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      paper: {
        backgroundColor: '#FFFFFF',
        boxShadow: '0 1px 3px 0 rgba(0,0,0,0.25)',
        borderRadius: '4px',
        outline: 'none',
        maxWidth: matches ? '85%' : '50%',
      },
      header: {
        backgroundColor: '#FFFFFF',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
        boxShadow: '0 1px 3px 0 rgba(0,0,0,0.25)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 16px',
        borderBottom: '1px solid #E7E7E7',
      },
      footer: {
        backgroundColor: '#FFFFFF',
        boxShadow: '0 1px 3px 0 rgba(0,0,0,0.25)',
        borderTop: '1px solid #E7E7E7',
        padding: '12px 16px',
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
      },
      content: {
        backgroundColor: '#FFFFFF',
        position: 'relative',
        padding: '18px 16px',
      },
      iconImage: {
        cursor: 'pointer',
        padding: 10,
        '&:hover': {
          background: 'rgba(0,0,0,0.04)',
        },
      },
      Backdrop: {
        background: 'rgba(0,0,0,0.6)',
      },
    }),
  );

  const classes = useStyles();
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={props.open}
      onClose={props.handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        classes: { root: classes.Backdrop },
      }}
    >
      <div className={classes.paper}>
        {props.header ? (
          <div className={classes.header}>
            {props.header}
            <img
              className={classes.iconImage}
              alt=""
              onClick={() => props.handleClose()}
              src={AssuranceIcon['X']}
            />
          </div>
        ) : (
          <></>
        )}
        <div className={classes.content}>{props.content}</div>
        {props.footer ? (
          <div className={classes.footer}>{props.footer}</div>
        ) : (
          <></>
        )}
      </div>
    </Modal>
  );
}
